import React from "react";
import styles from "./partnersCta.module.scss";
import ExternalLink from "@components/ExternalLink/externalLink"

const PartnersCta = ({ ctaTitle, ctaSubtitle, ctaText, ctaLink }) => (
  <div className={styles.partnersCta}>
    <h2 className={styles.partnersCta__title}>
      {ctaTitle}
    </h2>
    <h3 className={styles.partnersCta__subtitle}>
      {ctaSubtitle}
    </h3>
    <ExternalLink href={ctaLink} title={ctaText} className={'button'}>
      {ctaText}
    </ExternalLink>
  </div>
);

export default PartnersCta;
